import { createClient, type Session, type SupabaseClient } from '@supabase/supabase-js';

const URL = import.meta.env.VITE_SUPABASE_URL?.trim() ?? '';
const KEY = import.meta.env.VITE_SUPABASE_ANON_KEY?.trim() ?? '';

export const PRODUCT = (import.meta.env.VITE_PRODUCT as string | undefined) ?? 'bebecare';

export const isSupabaseConfigured = Boolean(URL && KEY);

if (!isSupabaseConfigured) {
  console.error(
    '[web] Faltam VITE_SUPABASE_URL ou VITE_SUPABASE_ANON_KEY.\n' +
      '  Preencha apps/web/.env ou use o switch central em .env.local\n' +
      '  e reinicie: npm run dev\n' +
      '  Publishable key pública: .env.local (switch central) ou Dashboard → API',
  );
}

/** Evita crash do createClient quando a anon key está vazia (tela ConfigMissing). */
export const supabase: SupabaseClient = isSupabaseConfigured
  ? createClient(URL, KEY, {
      auth: {
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: true,
        // OTP pelo app usa PKCE (?code=); generate_link /verify usa hash — tratado em finishAuthFromUrl.
        flowType: 'pkce',
      },
    })
  : createClient('https://placeholder.supabase.co', 'placeholder-key-not-used', {
      auth: {
        persistSession: false,
        autoRefreshToken: false,
        detectSessionInUrl: false,
      },
    });

export type { Session };
